"use strict";

/**
 * Implements navigation bar functionality.
 */
export default class NavBar {
	constructor() {
		this.navbar = document.querySelector( '.navbar' );
		if ( ! this.navbar ) {
			return;
		}
		var magnifier = this.navbar.querySelector( '.navbar__magnifier' );
		magnifier.addEventListener( 'click', (event) => {
			event.preventDefault();
			this.navbar.classList.toggle( 'navbar--searchform' );
			document.body.classList.remove( 'page-menu-visible' );
			this.navbar.classList.remove( 'navbar--page-menu' );
		} );

		var pageMenu = document.querySelector( '.page-menu' );
		if ( pageMenu ) {
			var closePageMenu = document.createElement( 'a' );
			closePageMenu.href = '#';
			closePageMenu.classList.add( 'navbar__close-page-menu' );
			pageMenu.appendChild( closePageMenu );
		};

		var burger = this.navbar.querySelector( '.navbar__burger' );

		[ burger, closePageMenu ].forEach( ( button ) => {
			if ( ! button ) {
				return;
			}
			button.addEventListener( 'click', (event) => {
				event.preventDefault();
				document.body.classList.toggle( 'page-menu-visible' );
				this.saveSetting(
					window.matchMedia( '(min-width: 992px)' ).matches &&
					document.body.classList.contains( 'page-menu-visible' )
				);
				this.navbar.classList.toggle( 'navbar--page-menu' );
				this.navbar.classList.remove( 'navbar--searchform' );
			} );
		} );
	};


	/**
	 * Saves the current setting via XHR.
	 */
	async saveSetting( unfolded ) {
		const opts = {
			headers: {
				'X-WP-Nonce': wpApiSettings.nonce,
			},
			method: 'PUT',
			body: JSON.stringify(
				{
					key: 'page_menu_unfolded',
					value: unfolded,
				}
			),
		};
		await fetch(
			wpApiSettings.root + 'iportal/v1/user_options',
			opts
		);
	};

};
